import { render, staticRenderFns } from "./currencyFormatters.vue?vue&type=template&id=244b0d8a&"
import script from "./currencyFormatters.vue?vue&type=script&lang=js&"
export * from "./currencyFormatters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports